var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sas-dashboard-container" }, [
    _c(
      "div",
      { staticClass: "slider-btn", on: { click: _vm.openDraw } },
      [
        _c(
          "el-tooltip",
          {
            staticClass: "item",
            attrs: {
              effect: "dark",
              content: _vm.$t("sas_dashboard_title"),
              placement: "left",
              "popper-class": "popper-cls",
            },
          },
          [
            _c("img", {
              staticClass: "history-icon",
              attrs: { src: _vm.dashboard_icon, alt: "", width: "100%" },
            }),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "body" },
      [
        _c(
          "el-drawer",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "drawer-wrapper",
            attrs: {
              size: _vm.exportLoading ? "30%" : "50%",
              visible: _vm.show,
              "append-to-body": true,
              "modal-append-to-body": false,
              modal: false,
              direction: "rtl",
              "before-close": _vm.onDrawClose,
              "destroy-on-close": "",
            },
            on: {
              "update:visible": function ($event) {
                _vm.show = $event
              },
              open: _vm.onDrawOpen,
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c("div", { staticClass: "draw-title" }, [
                      _c("div", { staticClass: "draw-title-text" }, [
                        _vm._v(_vm._s(_vm.$t("sas_dashboard_title"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            [
              _c("div", { staticClass: "draw-body" }, [
                _c(
                  "div",
                  { staticClass: "draw-section-title" },
                  [
                    _c("div", { staticClass: "section-title-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("each_milestone_completion_time_allocation")
                        )
                      ),
                    ]),
                    _c("el-cascader", {
                      staticClass: "section-title-cascader",
                      attrs: {
                        options: _vm.cascaderOptions1,
                        size: "mini",
                        props: {
                          value: "id",
                          label: "milestoneName",
                          children: "childMilestoneBO",
                        },
                      },
                      on: { change: _vm.onChart1SelectChange },
                      model: {
                        value: _vm.dashboardMilestoneId1,
                        callback: function ($$v) {
                          _vm.dashboardMilestoneId1 = $$v
                        },
                        expression: "dashboardMilestoneId1",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", {
                  ref: "chart1",
                  staticClass: "section-chart-container",
                  attrs: { id: "chart1" },
                }),
                _c(
                  "div",
                  { staticClass: "draw-section-title" },
                  [
                    _c("div", { staticClass: "section-title-text" }, [
                      _vm._v(
                        _vm._s(_vm.$t("each_milestone_progress_overview"))
                      ),
                    ]),
                    _c("el-cascader", {
                      staticClass: "section-title-cascader",
                      attrs: {
                        options: _vm.cascaderOptions2,
                        size: "mini",
                        props: {
                          value: "id",
                          label: "milestoneName",
                          children: "childMilestoneBO",
                        },
                      },
                      on: { change: _vm.onChart2SelectChange },
                      model: {
                        value: _vm.dashboardMilestoneId2,
                        callback: function ($$v) {
                          _vm.dashboardMilestoneId2 = $$v
                        },
                        expression: "dashboardMilestoneId2",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", {
                  ref: "chart2",
                  staticClass: "section-chart-container",
                  attrs: { id: "chart2" },
                }),
                _c(
                  "div",
                  { staticClass: "draw-section-title" },
                  [
                    _c("div", { staticClass: "section-title-text" }, [
                      _vm._v(_vm._s(_vm.$t("all_entities_progress_overview"))),
                    ]),
                    _c(
                      "el-select",
                      {
                        staticClass: "section-title-cascader",
                        attrs: { size: "mini" },
                        model: {
                          value: _vm.dashboardMilestoneId3,
                          callback: function ($$v) {
                            _vm.dashboardMilestoneId3 = $$v
                          },
                          expression: "dashboardMilestoneId3",
                        },
                      },
                      _vm._l(_vm.cascaderOptions3, function (v, k) {
                        return _c("el-option", {
                          key: k,
                          attrs: { label: v.milestoneName, value: v.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    ref: "chart3",
                    staticClass: "section-chart-container-3",
                    attrs: { id: "chart3" },
                  },
                  [
                    _c("div", { staticClass: "chart3-egs" }, [
                      _c("div", { staticClass: "eg-item" }, [
                        _c("div", {
                          ref: "egGreen",
                          staticClass: "eg-color eg-color-green",
                        }),
                        _c("div", { staticClass: "eg-text" }, [
                          _vm._v(_vm._s(_vm.$t("sas_dashboard_examples_14"))),
                        ]),
                      ]),
                      _c("div", { staticClass: "eg-item" }, [
                        _c("div", {
                          ref: "egGray",
                          staticClass: "eg-color eg-color-gray",
                        }),
                        _c("div", { staticClass: "eg-text" }, [
                          _vm._v(_vm._s(_vm.$t("sas_dashboard_examples_23"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.statsData[2],
                          "cell-style": _vm.chart3CellStyle,
                          "row-style": { height: "44px" },
                          fit: true,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            fixed: "",
                            width: "150",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", {
                                    staticClass: "chart3-entity-name-inner",
                                    domProps: {
                                      innerHTML: _vm._s(scope.row.entityName),
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c(
                          "el-table-column",
                          {
                            attrs: {
                              label: _vm.chart3Level1Label,
                              align: "center",
                            },
                          },
                          _vm._l(_vm.chart3Level2Columns, function (v, k) {
                            return _c("el-table-column", {
                              key: k,
                              attrs: {
                                "column-key": v.id,
                                label: v.milestoneName,
                                width: "100",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function () {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              placement: "top",
                                              effect: "light",
                                            },
                                          },
                                          [
                                            _c("div", {
                                              attrs: { slot: "content" },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  v.milestoneName
                                                ),
                                              },
                                              slot: "content",
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "chart3-header-outer",
                                              },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "chart3-header-inner",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      v.milestoneName
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }